import { render, staticRenderFns } from "./ProjectViewNotification.vue?vue&type=template&id=bf5755da&"
import script from "./ProjectViewNotification.vue?vue&type=script&lang=js&"
export * from "./ProjectViewNotification.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports